import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { gkComments } from "@/mocks/comments";
import { gkCategories } from "@/mocks/categories";

const SITE = "https://dqxuaad.cn";

const principles = [
  { icon: "ri-checkbox-circle-line", title: "每日准时", desc: "坚持每日瓜料准时更新，早午晚三批推送，让追瓜成为每天的确定时刻。" },
  { icon: "ri-focus-3-line", title: "有据可查", desc: "爆料尽量标注来源与推测成分，网传信息如实说明，帮读者吃瓜不吃假。" },
  { icon: "ri-empathize-line", title: "理性克制", desc: "不煽动、不造谣，尊重当事人，倡导快乐冲浪也守住底线。" },
];

const milestones = [
  { num: "30+", label: "栏目常驻栏目与子话题" },
  { num: "100w+", label: "月均瓜料阅读热度" },
  { num: "50+", label: "编辑与热心瓜友共创" },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于看吃瓜 - 品牌介绍与内容理念"
        description="了解看吃瓜的品牌定位、发展理念与内容原则。我们坚持每日瓜料准时更新，从今日新瓜到最新爆料，做有态度的娱乐资讯门户。"
        canonicalPath="/about"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于看吃瓜",
            description: "看吃瓜品牌介绍与内容理念",
            url: `${SITE}/about`,
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "看吃瓜",
            url: SITE,
            sameAs: [],
            contactPoint: [{ "@type": "ContactPoint", email: "hello@kanchigua.example", contactType: "customer service", areaServed: "CN", availableLanguage: "zh-CN" }],
          },
        ]}
      />

      {/* Hero */}
      <section className="mx-auto max-w-7xl px-4 pt-8 md:px-8 md:pt-12">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-700 p-8 md:p-14">
          <div className="absolute -right-8 -top-10 h-52 w-52 rounded-full bg-background-50/10"></div>
          <div className="absolute bottom-0 right-32 h-32 w-32 rounded-full bg-background-50/10"></div>
          <nav aria-label="面包屑" className="relative mb-6 flex items-center gap-2 text-xs text-background-50/80">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-50">关于我们</span>
          </nav>
          <h1 className="relative font-heading text-3xl font-bold text-background-50 md:text-5xl">关于看吃瓜</h1>
          <p className="relative mt-4 max-w-2xl text-base leading-8 text-background-50/90 md:text-lg">
            看吃瓜是一份每日准时更新的娱乐资讯“瓜田报”。从今日新瓜到最新爆料，从明星动态到全网热点，我们负责第一时间把值得吃的瓜端到你面前。
          </p>
        </div>
      </section>

      {/* Brand story */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600"><span className="inline-block h-px w-6 bg-primary-500"></span>品牌介绍</p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950">我们为什么做“看吃瓜”</h2>
            <div className="mt-5 space-y-4 text-[15px] leading-8 text-foreground-700">
              <p>信息爆炸的年代，热点来得快去得也快，很多人其实并非不爱吃瓜，而是被碎片化的信息弄晕了头——不知道哪条是真的、哪条已过时、哪条值得深聊。</p>
              <p>于是我们想做这样一个去处：它像一张有温度的瓜田晚报，把散落在各处的娱乐新鲜事梳理成今日新瓜、最新爆料和每日瓜料，用编辑的眼光帮你“扫一眼就明白今天在聊什么”。</p>
              <p>我们不追求标题的惊悚，只希望每一条瓜都信息清楚、来路明白。看吃瓜想成为你通勤路上、午休间隙最轻松的“每日例行吃瓜”。</p>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {milestones.map((m) => (
              <div key={m.label} className="rounded-2xl border border-background-200 bg-background-50 p-5 text-center">
                <p className="font-heading text-2xl font-bold text-primary-500 md:text-3xl">{m.num}</p>
                <p className="mt-2 text-xs leading-5 text-foreground-600">{m.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="bg-background-100/60">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600"><span className="inline-block h-px w-6 bg-primary-500"></span>内容原则</p>
          <h2 className="font-heading text-3xl font-bold text-foreground-950">我们坚持的三件事</h2>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {principles.map((p) => (
              <div key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600"><i className={`${p.icon} text-xl`}></i></span>
                <h3 className="mt-4 font-heading text-xl font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-2 text-sm leading-7 text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision & columns */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-2">
          <div className="rounded-3xl bg-accent-50/70 p-6 md:p-8">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50"><i className="ri-eye-line text-xl"></i></span>
            <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-900">发展理念</h3>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              吃瓜的本质是“连接”：连接你与热点、连接同好之间的谈资。因此我们相信，一个健康的吃瓜社区，应建立在“更新准时、信息有据、表达有度”的共识之上。未来我们希望把栏目做得更深，让每条瓜不仅能被刷到，更值得被聊两句。
            </p>
          </div>
          <div>
            <h3 className="font-heading text-2xl font-bold text-foreground-900">五大栏目瓜田</h3>
            <p className="mt-2 text-sm text-foreground-600">从哪开吃都行，总有一款合你口味。</p>
            <div className="mt-5 grid gap-3 sm:grid-cols-2">
              {gkCategories.map((c) => (
                <Link key={c.slug} to={`/category/${c.slug}`} className="group flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600"><i className={c.icon}></i></span>
                  <div>
                    <p className="font-semibold text-foreground-900 group-hover:text-primary-600">{c.name}</p>
                    <p className="text-xs text-foreground-500">{c.tagline}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-background-100/60">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600"><span className="inline-block h-px w-6 bg-primary-500"></span>用户口碑</p>
          <h2 className="font-heading text-3xl font-bold text-foreground-950">瓜友们怎么说</h2>
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {gkComments.map((c) => (
              <figure key={c.nickname} className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${c.accent}`}>{c.avatarText}</span>
                  <div>
                    <figcaption className="text-sm font-semibold text-foreground-900">{c.nickname}</figcaption>
                    <p className="text-xs text-foreground-500">{c.role}</p>
                  </div>
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-6 text-foreground-700">“{c.text}”</blockquote>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-8 rounded-3xl border border-background-200 bg-background-50 p-6 md:p-10 lg:grid-cols-2">
          <div>
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600"><i className="ri-mail-send-line text-xl"></i></span>
            <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-900">联系与投稿</h3>
            <p className="mt-2 text-sm leading-7 text-foreground-600">无论是提供瓜料线索、栏目建议，还是合作洽谈，都欢迎与我们联系。我们会在工作日内尽快回复。</p>
            <div className="mt-5 space-y-3 text-sm text-foreground-700">
              <p className="flex items-center gap-3"><i className="ri-mail-line text-primary-500"></i>投稿 / 线索：tougao@kanchigua.example</p>
              <p className="flex items-center gap-3"><i className="ri-hand-heart-line text-primary-500"></i>合作：hello@kanchigua.example</p>
              <p className="flex items-center gap-3"><i className="ri-time-line text-primary-500"></i>每日更新 · 周末热点加更</p>
            </div>
          </div>
          <div className="flex items-center justify-center rounded-2xl bg-accent-50/70 p-8 text-center">
            <div>
              <p className="font-heading text-2xl font-bold text-accent-800">理性吃瓜，快乐冲浪</p>
              <p className="mt-2 text-sm text-foreground-600">愿看吃瓜陪你度过每一个轻松的下瓜时刻。</p>
              <Link to="/" className="mt-5 inline-block rounded-full bg-accent-500 px-6 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 hover:bg-accent-600">去吃今日的新瓜</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}